import { StyledFormGroupError } from 'components/shared/FormGroup.styled';
import { Heading4 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';

export const StyledContainer = styled.div`
  background-color: var(--out-of-office-blue);
  display: flex;
  flex-direction: column;
  clip-path: polygon(0 10%, 100% 0, 95% 100%, 5% 95%);
  margin-bottom: ${spacing('xl4')};
  padding-top: ${spacing('xl4')};
  padding-bottom: ${spacing('xl4')};
  padding-left: ${spacing('xl')};
  padding-right: ${spacing('xl')};
  color: ${color('white')};

  @media (min-width: ${screen('md')}) {
    clip-path: polygon(0 10%, 100% 0, 95% 100%, 5% 90%);
    margin-left: ${spacing('xl3')};
    margin-right: ${spacing('xl3')};
    padding-left: ${spacing('xl4')};
    padding-right: ${spacing('xl5')};
    padding-bottom: ${spacing('xl5')};
  }

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    padding-top: ${spacing('xl3')};
    padding-bottom: ${spacing('xl4')};
    margin-bottom: ${spacing('xl6')};
  }

  img {
    max-width: 15.5rem;
    flex-shrink: 0;
  }

  ${Heading4} {
    font-family: ${fontFamily('sans')};
    font-weight: ${fontWeight('black')};
    line-height: 1.3;
    margin-bottom: ${spacing('md')};
  }

  p {
    font-size: ${fontSize('md')};
    line-height: 1.5;
    margin: 0;

    @media (min-width: ${screen('md')}) {
      font-size: ${fontSize('lg')};
      line-height: 1.6;
    }
  }
`;

export const StyledForm = styled.form`
  margin-top: ${spacing('mdlg')};
  margin-bottom: ${spacing('md')};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: ${spacing('mdlg')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    align-items: flex-end;
  }

  button {
    height: 3.5rem;
  }

  ${StyledFormGroupError} {
    @media (min-width: ${screen('md')}) {
      position: absolute;
    }
  }
`;
